var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"t-badge",class:[
    ("t-badge--" + _vm.type),
    { 't-badge--soft': _vm.soft },
    { 't-badge--rounded': _vm.rounded } ]},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }